"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Returns a function that deletes all existing values
 * for the path, and then adds the given values to the path.
 *
 * Requires:
 * - a delete function on the path proxy.
 * - an add function on the path proxy.
 */

var SetFunctionHandler =
/*#__PURE__*/
function () {
  function SetFunctionHandler() {
    _classCallCheck(this, SetFunctionHandler);
  }

  _createClass(SetFunctionHandler, [{
    key: "handle",
    value: function handle(pathData, path) {
      return function () {
        var _path$delete;

        return (_path$delete = path.delete()).add.apply(_path$delete, arguments);
      };
    }
  }]);

  return SetFunctionHandler;
}();

exports.default = SetFunctionHandler;